import './App.css';
import { Link } from 'react-router-dom';

export default function Legal() {
  return (
    <div className="App">
      <div className="Shell">
        <header className="Header">
          <div className="Brand">
            <div className="BrandTitle">PhishNLearn</div>
            <div className="BrandSubtitle">הצהרה משפטית / כתב ויתור</div>
          </div>
        </header>

        <main className="Main">
          <section className="Card" style={{ maxWidth: 820, margin: '0 auto', width: '100%' }}>
            <div className="SectionTitle">כתב ויתור והצהרת שימוש (Disclaimer)</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              האתר נבנה למטרות חינוכיות והדגמה בלבד. הניתוח הוא טכני-אוטומטי המבוסס על מאפייני URL
              ואינו מהווה ייעוץ מקצועי (לרבות ייעוץ משפטי, אבטחתי או פיננסי) ואינו המלצה לפעולה.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">אין אחריות</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              השימוש באתר הוא באחריות המשתמש בלבד. בעלי האתר/המפתחים/המפעילים אינם אחראים לכל נזק
              ישיר או עקיף, הפסד, אובדן מידע, פגיעה בפרטיות, פגיעה במוניטין או כל תוצאה אחרת הנובעת
              מהסתמכות על התוצאות, מהשימוש באתר או מאי-יכולת להשתמש בו.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">דיוק התוצאות</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              התוצאות עשויות להיות שגויות (False Positives/False Negatives). אין התחייבות לכך שהתוצר
              יזהה כל ניסיון פישינג או שכל קישור המסומן כבטוח אכן בטוח.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">דינמיות האיומים</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              איומי סייבר והתקפות פישינג משתנים כל הזמן. תוצאה “בטוחה” נכונה לרגע הבדיקה בלבד ואינה
              מבטיחה שהאתר לא יהפוך לזדוני בעתיד.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">שימוש על אחריותכם</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              מומלץ לא להזין פרטים אישיים/סיסמאות/מידע פיננסי דרך קישורים שקיבלתם בהודעות, גם אם
              התוצאה באתר נראית “בטוחה”. תמיד בדקו את הדומיין באופן ידני ובערוצים הרשמיים של הגוף
              הרלוונטי.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">פרטיות ונתונים</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              הקישורים המוזנים לכלי נשלחים לשרת לצורך ניתוח בזמן אמת בלבד. האתר אינו שומר את
              הקישורים בבסיס נתונים לאחר סיום הבדיקה ואינו אוסף מידע אישי על המשתמשים מעבר לנדרש
              לפעולה הטכנית של השירות.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">תוכן צד ג'</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              כחלק מהניתוח, השרת עשוי לפנות לאתרים חיצוניים (צד ג'). האתר משמש ככלי ניתוח בלבד ואין
              לראות בתוצאה משום הבעת עמדה, אחריות או אחריות משתמעת לגבי התוכן, המוצרים או השירותים
              באתרים אלה.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">קניין רוחני וסימני מסחר</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              שמות וסימני מסחר של צדדים שלישיים (כגון Google, Facebook, Skype וכדומה) הינם בבעלות
              בעליהם החוקיים. הם מוזכרים בכלי לצורכי השוואה וזיהוי ניסיונות התחזות בלבד ואינם מעידים
              על קשר, אישור או חסות מטעמם.
            </div>

            <div style={{ height: 14 }} />
            <div className="SectionTitle">שינויים וזמינות</div>
            <div className="Muted" style={{ lineHeight: 1.7 }}>
              ייתכנו תקלות, השבתות ושינויים ללא הודעה מוקדמת. ייתכן שהאתר יפסיק לפעול בכל עת.
            </div>

            <div style={{ height: 16 }} />
            <div>
              <Link className="Link" to="/">
                חזרה למסך הראשי
              </Link>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

